import Modal from 'react-modal'
import React from 'react'
import { Input, Button } from 'loyal-react'
import PropTypes from 'prop-types'

const ParticipantModal = ({
  modal,
  isValidName,
  isValidEmail,
  isValidLogin,
  isValidPoints,
  disableFields,
  participant,
  handleName,
  handleLogin,
  handleEmail,
  handlePoints,
  toggleModal,
  submit
}) => {
  return (
    <Modal
      isOpen={modal}
      onRequestClose={toggleModal}
      style={{
        content: {
          top: '60%',
          left: '50%',
          right: 'auto',
          bottom: 'auto',
          marginRight: '-50%',
          transform: 'translate(-50%, -50%)',
          width: '600px'
        }
      }}
    >
      <div className='row'>
        <div className='col-12'>
          <h2 className='txt-initial color-brand-1 mr-auto'>
            Adicionar Participante
          </h2>
        </div>
      </div>
      <hr />
      <div className='row mt-2'>
        <div className='col-12'>
          <Input
            id='login'
            label='CPF'
            mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
            value={participant.login}
            data-error='O CPF é inválido ou já está incluído na tabela de participantes'
            valid={isValidLogin}
            onChange={handleLogin}
          />
        </div>
      </div>
      <div className='row mt-2'>
        <div className='col-12'>
          <Input
            id='name'
            label='Nome Completo'
            value={participant.name}
            disabled={disableFields}
            data-error='Informe um nome válido'
            valid={isValidName}
            onChange={handleName}
          />
        </div>
      </div>
      <div className='row mt-2'>
        <div className='col-12'>
          <Input
            id='email'
            label='E-mail'
            value={participant.email}
            disabled={disableFields}
            data-error='Informe um email válido'
            valid={isValidEmail}
            onChange={handleEmail}
          />
        </div>
      </div>
      <div className='row mt-2'>
        <div className='col-12'>
          <Input
            id='value'
            label='Quantidade de pontos a distribuir'
            value={participant.value}
            data-error='O valor disponível é menor que o informado'
            valid={isValidPoints}
            onChange={handlePoints}
          />
        </div>
      </div>
      <div className='row mt-2'>
        <div className='col-6'>
          <Button
            id='closeModal'
            name='closeModal'
            className='btn btn-sm mx-0'
            text='Fechar'
            onClick={() => toggleModal('participantModal')}
          />
        </div>
        <div className='col-6'>
          <Button
            id='save'
            name='save'
            className='btn btn-sm txt-uppercase txt-center btn-featured'
            text='Salvar'
            disabled={(!isValidPoints || !isValidLogin || !isValidName || !isValidEmail) ? 'disabled' : ''}
            onClick={submit}
          />
        </div>
      </div>
    </Modal>
  )
}

ParticipantModal.propTypes = {
  modal: PropTypes.bool,
  isValidName: PropTypes.bool,
  isValidEmail: PropTypes.bool,
  isValidLogin: PropTypes.bool,
  isValidPoints: PropTypes.bool,
  disableFields: PropTypes.bool,
  participant: PropTypes.object,
  handleName: PropTypes.func,
  handleLogin: PropTypes.func,
  handleEmail: PropTypes.func,
  handlePoints: PropTypes.func,
  toggleModal: PropTypes.func,
  submit: PropTypes.func
}

export default ParticipantModal



// WEBPACK FOOTER //
// ./src/features/FocalPoint/Participant/ParticipantModal.js